function URL (url) {
  const protocol = url.indexOf('https:') > -1 ? 'https:' : (url.indexOf('http:') > -1 ? 'http:' : '')
  let _subUrl = url.replace(`${protocol}//`, '')
  const hashIndex = _subUrl.indexOf('#')
  const hash = hashIndex > -1 ? _subUrl.substr(hashIndex, _subUrl.length) : ''
  const searchIndex = _subUrl.indexOf('?')
  const search = searchIndex > -1 ? _subUrl.substr(searchIndex, _subUrl.length) : ''
  const pathArr = _subUrl.split('/')

  let host = ''
  let port = ''
  let hostname = ''
  let pathname = '/'
  if (pathArr.length > 0) {
    host = pathArr[0]
    let portIndex = host.indexOf(':')
    if (portIndex > -1) {
      port = host.substr(portIndex + 1, host.length)
      hostname = host.substr(0, portIndex)
    } else {
      hostname = host
    }
  }
  pathname = pathArr.length < 2 ? '/' : `${_subUrl.replace(host, '').replace(search, '').replace(hash, '')}`
  return {
    hash: hash,
    host: host,
    hostname: hostname,
    href: url,
    origin: `${protocol}//${host}`,
    pathname: pathname,
    port: port,
    protocol: protocol,
    search: search,
    username: ''
  }
}

export default URL
